import { TICKER_SYMBOLS } from "../lib/constants";
import { TrendingUp, TrendingDown } from "lucide-react";

function TickerRow() {
    return (
        <>
            {TICKER_SYMBOLS.map((t, i) => (
                <span
                    key={i}
                    data-testid={`ticker-item-${t.symbol.replace(/[^a-zA-Z0-9]/g, "")}`}
                    className="group inline-flex items-center gap-2 px-5 font-mono text-[11px] border-r border-line"
                >
                    <span className="font-medium uppercase tracking-[0.08em] text-accent">{t.symbol}</span>
                    <span className="text-foreground tabular-nums">{t.value}</span>
                    <span
                        className={`inline-flex items-center gap-1 text-[10px] font-medium tabular-nums ${
                            t.up ? "text-pos" : "text-neg"
                        }`}
                    >
                        {t.up ? <TrendingUp size={10} /> : <TrendingDown size={10} />}
                        {t.change}
                    </span>
                </span>
            ))}
        </>
    );
}

// The tape: a quiet white strip above the masthead, ruled off between
// quotes so it reads as a printed table rather than a row of chips.
export function StockTicker() {
    return (
        <div
            className="relative h-9 flex items-center overflow-hidden border-b border-line bg-surface"
            data-testid="stock-ticker"
        >
            <span className="hidden sm:inline-flex items-center gap-2 h-full pl-4 pr-5 shrink-0 border-r border-line bg-accent-soft">
                <span className="w-1.5 h-1.5 rounded-full bg-accent animate-pulse-dot" />
                <span className="font-mono text-[10px] font-medium uppercase tracking-[0.2em] text-accent">
                    Markets
                </span>
            </span>
            <div className="relative flex-1 overflow-hidden">
                <div className="ticker-track">
                    <TickerRow />
                    <TickerRow />
                </div>
                {/* Edge fades so quotes dissolve into the paper rather than clip */}
                <div className="pointer-events-none absolute inset-y-0 left-0 w-8 bg-gradient-to-r from-surface to-transparent" />
                <div className="pointer-events-none absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-surface to-transparent" />
            </div>
        </div>
    );
}
